const REMINDER_READ_STORAGE_KEY = 'qureo.readReminderIds';

const readReminderIdsFromStorage = () => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const value = window.localStorage.getItem(REMINDER_READ_STORAGE_KEY);
    const parsed = value ? JSON.parse(value) : [];
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
};

const writeReminderIdsToStorage = (ids) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(REMINDER_READ_STORAGE_KEY, JSON.stringify(Array.from(new Set(ids))));
};

export const getReadReminderIds = () => new Set(readReminderIdsFromStorage());

export const isReminderRead = (reminderId) => getReadReminderIds().has(reminderId);

export const markReminderRead = (reminderId) => {
  if (!reminderId) {
    return;
  }

  const ids = readReminderIdsFromStorage();
  ids.push(reminderId);
  writeReminderIdsToStorage(ids);
};

export const markReminderUnread = (reminderId) => {
  if (!reminderId) {
    return;
  }

  writeReminderIdsToStorage(readReminderIdsFromStorage().filter((id) => id !== reminderId));
};

export const markAllRemindersRead = (reminderIds = []) => {
  if (!Array.isArray(reminderIds) || reminderIds.length === 0) {
    return;
  }

  writeReminderIdsToStorage([...readReminderIdsFromStorage(), ...reminderIds]);
};

export const removeReminderReadState = (reminderId) => {
  markReminderUnread(reminderId);
};